import { useFunnelContext } from "shared/Funnel/FunnelContextProvider";
import { Variant } from "shared/product/ProductSection/product-section.helper";
import { getSeniorityThreshold } from "utils/usePriceAdvantage";
import { useI18n } from "utils/with-i18n.utils";

import Calendar from "./calendar.svg";
import DeviceSync from "./device-sync.svg";
import Medal from "./medal.svg";
import Security from "./security.svg";
import Truck from "./truck.svg";

export const AdvantageDetails = ({
  currentVariant,
  freeChangeAfterMonths,
}: {
  currentVariant: Variant | undefined;
  freeChangeAfterMonths?: number;
}) => {
  const i18n = useI18n();
  const { isSwap } = useFunnelContext();

  const commonIconTranslationKeyList = [
    {
      icon: <Security />,
      translationKey: "product.conditions.insurances",
    },
    {
      icon: <Truck />,
      translationKey: "product.conditions.freePickupStore",
    },
    {
      icon: <Medal />,
      translationKey: "product.conditions.insured",
    },
    {
      icon: <DeviceSync />,
      translationKey: "product.conditions.freeSwap",
      params: {
        seniorityThreshold:
          freeChangeAfterMonths ??
          getSeniorityThreshold({
            commitmentPeriod: currentVariant?.commitmentPeriod,
          }),
      },
    },
  ];

  const iconTranslationKeyList = isSwap
    ? commonIconTranslationKeyList
    : [
        {
          icon: <Calendar />,
          translationKey: "product.conditions.trial",
        },
        ...commonIconTranslationKeyList,
      ];

  return (
    <section className="relative pt-2 w-full max-w-md leading-5 bg-white">
      <div className="flex justify-center items-center py-2 text-white bg-black rounded-t-lg  border-black">
        {i18n.t("product.conditions")}
      </div>

      <ul
        className={"flex flex-col gap-3 p-4 rounded-b-md border-2 border-black"}
      >
        {iconTranslationKeyList.map(({ icon, translationKey, params }) => (
          <li className="flex gap-4 items-center" key={translationKey}>
            {icon}
            {i18n.t(translationKey, { ...params }, { html: true })}
          </li>
        ))}
      </ul>
    </section>
  );
};
